import {
  customizeVerticalScrollbarThumbMixin,
  disableSomeContentStyles
} from 'styles/mixins'
import styled, { css } from 'styled-components'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const Container = styled.section<{
  $disabled?: boolean
  $isLoading?: boolean
}>`
  width: 100%;
  height: 100%;
  padding-top: 18px;
  display: flex;
  flex-direction: column;
  position: relative;

  ${({ $disabled }) =>
    $disabled &&
    css`
      ${disableSomeContentStyles(0.5)}
    `}
`

export const ItemsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  overflow: hidden;
  justify-content: flex-start;
  align-content: flex-start;
  overflow-y: auto;
  ${customizeVerticalScrollbarThumbMixin()}

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    justify-content: flex-start;

    &::after {
      content: '';
      max-width: 48%;
      width: 100%;
    }
  }
`
